import * as React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import KfLogo from '../../../Assets/kflogo.png';

import {
    Button,
    // TextField,
    Checkbox,
    Theme as ITheme,
    WithStyles as IWithStyles,
    FormControl,
    Select,
    MenuItem,
    // Typography,
     InputLabel,
} from '@material-ui/core';
import { IRegisterForm } from './types';

const styles = (theme: ITheme) => ({
    card: {
        background: '#242424',
        // boxShadow: '0px 3px 12px #00000012',
        borderRadius: '20px',
        border: '1px solid #707070',
       maxWidth: '100%',
        width: '690px',
       padding: '45px 114px 12px',
       boxSizing: 'border-box',
       margin: '35px 0 5px',
        // [theme.breakpoints.down('lg')]: {
        //     padding: '47px 72px',
        // },
        [theme.breakpoints.down('md')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '47px 72px', 
            width: '550px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '20px 32px',
            width: '100%',
        },
        textAlign: 'center' as 'center',
    },
       logo: {
        marginBottom: '25px',
        width: '240px',
          [theme.breakpoints.down('sm')]: {
            width: '220px',
        },
          [theme.breakpoints.down('xs')]: {
           width: '180px',
           marginBottom: '10px',
        },
    },
    heading: {
        fonFamily: 'League Spartan',
        fontWeight: 'bold',
        fontSize: '28px',
        lineHeight: '38px',
        textTransform: 'uppercase' as 'uppercase',
        marginBotom: '56px',
        color: '#ffffff',
         [theme.breakpoints.down('sm')]: {
            fontSize: '28px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
        },
    },
    field: {
        width: '100%',
        marginTop: '20px',
        borderRadius: '0px',
        '& div': {
            borderRadius: '0px',
        },
        '& input': {
            background: '#fff',
            color: '#000',
            borderRadius: '0px',
        },
    },
    text: {
        marginTop: '20px',
        color: 'white',
    },
    formControl: {
        minWidth: 120,
            '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                    borderBottom: '1px solid #ffffff', 
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottom: '1px solid #ffffff',
            },
        '& .MuiSelect-root': {
            backgroundColor: '#242424',
            color: '#ffffff', 
            borderBottom: '1px solid #ffffff',
            paddingBottom: '2px',
            marginTop: '6px',
            fontSize: '15px',
            maxWidth: '200px',
            textAlign: 'left' as 'left', 
            [theme.breakpoints.down('md')]: {
                maxWidth: '100%',
            },
                
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 12px)',
            color: '#ffffff', 
        },
    },
    greeting: {
        color: '#fff',
        fontSize: '1em',
        width: '120%',
        marginBottom: '10px',
        fontWeight: 100,
    },
    submitBtnWrapper: {
        textAlign: 'center' as 'center',
    },
    submitBtn: {
        fontWeight: 600,
        background: '#db2c29',
        textTransform: 'none' as 'none',
        borderRadius: '24px',
        color: 'white',
        fontSize: '16px',
        lineHeight: '18px',
        padding: '12px 24px',
        width: '116px',
        boxSize: 'borderBox',
        height: '48px',
        letterSpacing: '0.5px',
        boxShadow: 'none',
        marginTop: '0',
        [theme.breakpoints.down('xs')]: {
            height: '40px',
            padding: '8px 16px',
            width: '104px',
            fontSize: '15px',
        },
        '&:disabled': {
            background: '#cccccc',
            color: '#666666',
        },
        '&:hover': {
            backgroundColor: '#B3211E',
        },
    },
    errorLabel: {
        marginBottom: '10px',
    },

    message: {
        padding: '0px',
        textAlign: 'center' as 'center',
        fontSize: '15px',
        lineHeight: '18px',
        margin: '30px 0px 20px',
        color: '#ffffff',
        letterSpacing: '0.5px',
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            fontSize: '15px',
            margin: '20px 0px 10px',
        },
    },
    link: {
        color: '#db2c29',
        paddingLeft: '4px',
        textDecoration: 'none',
        letterSpacing: '0.5px',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    emailOptIn: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        fontSize: '15px',
        textAlign: 'left' as 'left',
        fontWeight: 400,
        color: '#ffffff',
         [theme.breakpoints.down('xs')]: {
            fontSize: '15px',
        },
    },
    textField: {
        width: '100%',
        display: 'flex',
        aligItems: 'flex-start',
        flexDirection: 'column' as 'column',
        marginBottom: '35px',
        '&:last-child': {
            marginBottom: '0px',
        },
        [theme.breakpoints.down('xs')]: {
            marginBottom: '30px',
        },
    },

    labelField: {
        fontSize: '15px',
        lineHeight: '20px',
        textAlign: 'left' as 'left',
        fontWeight: 400,
        color: '#ffffff',
        maxWidth: '100%',
        wordWrap: 'break-word' as 'break-word',
         [theme.breakpoints.down('xs')]: {
            fontSize: '15px',
        },
    },
    inputField: {
         border: 'none',
        borderBottom: '1px solid #ffffff',
        padding: '0 4px',
        marginTop: '4px',
        background: 'transparent',
        outline: 'none',
        fontSize: '15px',
        letterSpacing: '0.7px',
        height: '38px',
        color: '#ffffff',
        caretColor: '#ffffff',
        [theme.breakpoints.down('xs')]: {
            height: '30px',
        },
    },
    inputFieldError: {
        border: 'none',
        borderBottom: '1px solid #db2c29',
        padding: '0 4px',
        height: '38px',
        marginTop: '4px',
        background: 'transparent',
        outline: 'none',
        color: '#ffffff',
        fontSize: '15px',
        letterSpacing: '0.7px',
         [theme.breakpoints.down('xs')]: {
            height: '30px',
        },
    },
    formWrapper: {
        marginTop: '24px',
        padding: '0px',
    },
    inputWrapper: {
        display: 'grid',
        [theme.breakpoints.down('lg')]: {
            gap: '16px',
        },
        [theme.breakpoints.down('md')]: {
            gap: '16px',
        },
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
            gap: '0px',
            marginBottom: '40px',
        },
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
            gap: '0px',
            marginBottom: '30px',
        },
        gridTemplateColumns: '1fr 1fr',
        gap: '17px',
        '&.dropdown-wrapper-main': {
             [theme.breakpoints.down('sm')]: {
            gap: '30px',
            marginBottom: '15px',
        },
        }
    },
    dropdownWrapper: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '0',
        },
    },
    termsWrapper: {
        marginTop: '25px',
        display: 'flex',
        flexDirection: 'column' as 'column',
        marginLeft: '-11px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0',
        [theme.breakpoints.down('xs')]: {
              marginTop: '0',
        },
    },
    footer: {
        marginTop: '20px',
        textAlign: 'center' as 'center',
        maxWidth: '300px',
        fontSize: '12px',
        fontStyle: 'italic',
        marginBottom: '60px',
    },
    cardOuterWrapper: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    trailText: {
        color: '#ffffff',
        fontWeight: 400,
        marginBottom: '0px',
        fontSize: '15px',
    },
    checkboxRoot: {
        marginRight: '4px',
            width: '30px',
            height: '30px',
         [theme.breakpoints.down('xs')]: {
            width: '25px',
            height: '25px',
            marginRight: '0',
        },
        '& svg': {
            width: '30px',
            height: '30px',
            [theme.breakpoints.down('xs')]: {
                width: '25px',
                height: '25px',
            },
        },
    },
    checkboxChecked: {
        '& svg': {
            width: '30px',
            height: '30px',
            [theme.breakpoints.down('xs')]: {
                width: '25px',
                height: '25px',
            },
        },
    },
});

interface IProps extends IWithStyles {
    onSubmit: (method: string) => void;
    form: IRegisterForm;
    onChange: (
        form: 'login' | 'register',
        field: string
    ) => (e: React.ChangeEvent<HTMLInputElement>) => void;

    emailIsInvalid: (form: 'login' | 'register') => boolean;
    formIsDisabled: (form: 'login' | 'register') => boolean;
}

export const registerBox = ({
    classes,
    form,
    onChange,
    onSubmit,
    emailIsInvalid,
    formIsDisabled,
}: IProps) => {
    return (
        <div className={classes.cardOuterWrapper}>
            <div className={classes.card}>
                <div className={classes.heading}>
                            <img src={KfLogo} className={classes.logo} />
                            </div>
                <div className={classes.heading}>SIGN UP</div>
                <form className={classes.formWrapper}>
                    <div className={classes.inputWrapper}>
                        <div
                            className={classes.textField}
                        >
                            <div className={classes.labelField}>First Name*</div>
                            <input
                                className={
                                    form.errors.state
                                        ? classes.inputFieldError
                                        : classes.inputField
                                }
                                autoComplete='off'
                                required={true}
                                id='firstName'
                                onChange={onChange('register', 'firstName')}
                                value={form.firstName}
                                placeholder=''
                            ></input>
                        </div>
                        <div
                            className={classes.textField}
                        >
                            <div className={classes.labelField}>Last Name*</div>
                            <input
                                className={
                                    form.errors.state
                                        ? classes.inputFieldError
                                        : classes.inputField
                                }
                                autoComplete='off'
                                required={true}
                                id='lastName'
                                onChange={onChange('register', 'lastName')}
                                value={form.lastName}
                                placeholder=''
                            ></input>
                        </div>
                    </div>

                    <div className={classes.textField}>
                        <div className={classes.labelField}>
                            Orgnisation Name*
                        </div>
                        <input
                            className={
                                form.errors.state
                                    ? classes.inputFieldError
                                    : classes.inputField
                            }
                            autoComplete='off'
                            required={true}
                            id='organizationName'
                            onChange={onChange('register', 'organizationName')}
                            value={form.organizationName}
                            placeholder=''
                        ></input>
                    </div>

                    <div className={classes.textField}>
                        <div className={classes.labelField}>Email*</div>
                        <input
                            className={
                                form.errors.state || emailIsInvalid('register')
                                    ? classes.inputFieldError
                                    : classes.inputField
                            }
                            autoComplete='off'
                            required={true}
                            id='email'
                            onChange={onChange('register', 'email')}
                            value={form.email}
                            placeholder=''
                        ></input>
                    </div>
                    <div className={classes.textField}>
                        <div className={classes.labelField}>Password*</div>
                        <input
                            className={
                                form.errors.state
                                    ? classes.inputFieldError
                                    : classes.inputField
                            }
                            autoComplete='off'
                            required={true}
                            type='password'
                            id='password'
                            onChange={onChange('register', 'password')}
                            value={form.password}
                            placeholder=''
                        ></input>
                    </div>
                    <div className={`${classes.inputWrapper} dropdown-wrapper-main`}>
                        <div
                            className={classes.dropdownWrapper}
                        >
                            <div className={classes.labelField}>
                                Had you heard of telestration before Keyframe ?
                            </div>
                            <FormControl className={classes.formControl}>
                                <Select
                                    id='telestrated'
                                    value={form.telestrated.select}
                                    onChange={onChange('register', 'telestrated')}
                                    name='select'
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value='yes'>Yes</MenuItem>
                                    <MenuItem value='no'>No</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ marginBottom: '0px' }}>
                            <div className={classes.dropdownWrapper}>
                                <div className={classes.labelField}>
                                    Where did you hear about Keyframe Sports?
                                </div>
                                <FormControl className={classes.formControl}>
                                    <Select
                                        id='referral-source'
                                        value={form['referral-source'].select}
                                        onChange={onChange(
                                            'register',
                                            'referral-source'
                                        )}
                                        name='select'
                                        MenuProps={{
                                        PaperProps: {
                                            style: {
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                            },
                                        },
                                    }}
                                    >
                                        <MenuItem value='twitter'>
                                            Twitter
                                        </MenuItem>
                                        <MenuItem value='facebook'>
                                            Facebook
                                        </MenuItem>
                                        <MenuItem value='instagram'>
                                            Instagram
                                        </MenuItem>
                                        <MenuItem value='youtube'>
                                            Youtube
                                        </MenuItem>
                                        <MenuItem value='search-engine'>
                                            Search engine (Google etc)
                                        </MenuItem>
                                        <MenuItem value='word-of-mouth'>
                                            Word of mouth
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                    <div className={classes.termsWrapper}>
                        <span className={classes.emailOptIn}>
                            <Checkbox
                                checked={form.emailOptIn}
                                style={{
                                    color: '#ffffff',
                                }}
                                onChange={onChange('register', 'emailOptIn')}
                                classes={{
                                    root: classes.checkboxRoot,
                                    checked: classes.checkboxChecked,
                                }}
                            />
                            <span>Receive emails from Keyframe</span>
                        </span>
                        <span className={classes.emailOptIn}>
                            <Checkbox
                                checked={form.agreeToTerms}
                                classes={{
                                    root: classes.checkboxRoot,
                                    checked: classes.checkboxChecked,
                                }}
                                onChange={onChange('register', 'agreeToTerms')}
                            />
                            <div style={{ wordWrap: 'break-word' }}>
                                I agree to the &nbsp;
                                <a
                                    style={{ paddingLeft: '0px' }}
                                    className={classes.link}
                                    href='https://www.keyframesports.com/files/Terms%20and%20Conditions%20Keyframe.pdf'
                                >
                                    terms of service
                                </a>
                            </div>
                        </span>
                    </div>

                    <div className={classes.submitBtnWrapper}>
                    <InputLabel
                    error={form.errors.state}
                                    className={classes.errorLabel}
                                    >
                        {form.errors.serverErrors}
                    </InputLabel> 
                        <Button
                            disabled={formIsDisabled('register')}
                            variant='contained'
                            color='primary'
                            onClick={() => onSubmit('register')}
                            className={classes.submitBtn}
                        >
                            Sign Up
                        </Button>
                    </div>
                    <div className={classes.message}>
                        <span>Already have login and password?</span>
                            <Link to='/login' className={classes.link}>
                            Sign In
                        </Link>
                    </div>
                </form>
            </div>
            <div className={classes.footer}>
                <div className={classes.trailText}>*Free 14 day trial</div>
            </div>
        </div>
    );
};

export const RegisterBox = withStyles(styles)(registerBox);
